"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkExperiment = checkExperiment;
exports.getExperimentErrors = getExperimentErrors;
exports.nextStepForExperiment = nextStepForExperiment;
exports.willTerminateCancelExperiment = willTerminateCancelExperiment;
Object.defineProperty(exports, "checkPlan", {
  enumerable: true,
  get: function () {
    return _plan.checkPlan;
  }
});
Object.defineProperty(exports, "checkRoles", {
  enumerable: true,
  get: function () {
    return _roles.checkRoles;
  }
});
Object.defineProperty(exports, "checkVariants", {
  enumerable: true,
  get: function () {
    return _variants.checkVariants;
  }
});
Object.defineProperty(exports, "checkMetrics", {
  enumerable: true,
  get: function () {
    return _metrics.checkMetrics;
  }
});
Object.defineProperty(exports, "checkTechSettings", {
  enumerable: true,
  get: function () {
    return _techSettings.checkTechSettings;
  }
});
Object.defineProperty(exports, "checkActivation", {
  enumerable: true,
  get: function () {
    return _activation.checkActivation;
  }
});
Object.defineProperty(exports, "checkExperimentReset", {
  enumerable: true,
  get: function () {
    return _checkExperimentReset.default;
  }
});
Object.defineProperty(exports, "checkExperimentOverrides", {
  enumerable: true,
  get: function () {
    return _overrides.checkExperimentOverrides;
  }
});
Object.defineProperty(exports, "checkExperimentOverrideGroups", {
  enumerable: true,
  get: function () {
    return _overrides.checkExperimentOverrideGroups;
  }
});
Object.defineProperty(exports, "checkSampleLaunch", {
  enumerable: true,
  get: function () {
    return _sampleLaunch.checkSampleLaunch;
  }
});
Object.defineProperty(exports, "checkOverride", {
  enumerable: true,
  get: function () {
    return _overrideManagement.checkOverride;
  }
});
Object.defineProperty(exports, "checkOverrideGroup", {
  enumerable: true,
  get: function () {
    return _overrideManagement.checkOverrideGroup;
  }
});
Object.defineProperty(exports, "getSelectedEnvironment", {
  enumerable: true,
  get: function () {
    return _rollout.getSelectedEnvironment;
  }
});
Object.defineProperty(exports, "hasPermission", {
  enumerable: true,
  get: function () {
    return _permissions.hasPermission;
  }
});
Object.defineProperty(exports, "isFeatureFlagActive", {
  enumerable: true,
  get: function () {
    return _featureFlag.default;
  }
});
Object.defineProperty(exports, "estimateDays", {
  enumerable: true,
  get: function () {
    return _sampleCalculatorEstimates.estimateDays;
  }
});
Object.defineProperty(exports, "calculateRawMeanDifference", {
  enumerable: true,
  get: function () {
    return _sampleCalculatorEstimates.calculateRawMeanDifference;
  }
});
Object.defineProperty(exports, "estimateSampleSize", {
  enumerable: true,
  get: function () {
    return _sampleCalculatorEstimates.estimateSampleSize;
  }
});
Object.defineProperty(exports, "calculateQualityScore", {
  enumerable: true,
  get: function () {
    return _experimentEvaluationScoreCalculation.calculateQualityScore;
  }
});
Object.defineProperty(exports, "experimentEnvironmentEnum", {
  enumerable: true,
  get: function () {
    return _enums.experimentEnvironmentEnum;
  }
});
Object.defineProperty(exports, "experimentStatusEnum", {
  enumerable: true,
  get: function () {
    return _enums.experimentStatusEnum;
  }
});
Object.defineProperty(exports, "experimentStatusEnumReverse", {
  enumerable: true,
  get: function () {
    return _enums.experimentStatusEnumReverse;
  }
});
Object.defineProperty(exports, "experimentTypeEnum", {
  enumerable: true,
  get: function () {
    return _enums.experimentTypeEnum;
  }
});
Object.defineProperty(exports, "featureFlagEnum", {
  enumerable: true,
  get: function () {
    return _enums.featureFlagEnum;
  }
});
Object.defineProperty(exports, "featureFlagEnumReverse", {
  enumerable: true,
  get: function () {
    return _enums.featureFlagEnumReverse;
  }
});
Object.defineProperty(exports, "metricTypeEnum", {
  enumerable: true,
  get: function () {
    return _enums.metricTypeEnum;
  }
});
Object.defineProperty(exports, "permissionEnum", {
  enumerable: true,
  get: function () {
    return _enums.permissionEnum;
  }
});
Object.defineProperty(exports, "permissionEnumReverse", {
  enumerable: true,
  get: function () {
    return _enums.permissionEnumReverse;
  }
});
Object.defineProperty(exports, "roleEnum", {
  enumerable: true,
  get: function () {
    return _enums.roleEnum;
  }
});
Object.defineProperty(exports, "roleEnumReverse", {
  enumerable: true,
  get: function () {
    return _enums.roleEnumReverse;
  }
});
Object.defineProperty(exports, "overrideTypeEnum", {
  enumerable: true,
  get: function () {
    return _enums.overrideTypeEnum;
  }
});
Object.defineProperty(exports, "tdcsInformCallTypeEnum", {
  enumerable: true,
  get: function () {
    return _enums.tdcsInformCallTypeEnum;
  }
});
Object.defineProperty(exports, "evaluationStatusEnum", {
  enumerable: true,
  get: function () {
    return _enums.evaluationStatusEnum;
  }
});
Object.defineProperty(exports, "evaluationCategoryEnum", {
  enumerable: true,
  get: function () {
    return _enums.evaluationCategoryEnum;
  }
});
Object.defineProperty(exports, "experimentCategoryEnum", {
  enumerable: true,
  get: function () {
    return _enums.experimentCategoryEnum;
  }
});
Object.defineProperty(exports, "experimentCategoryEnumReverse", {
  enumerable: true,
  get: function () {
    return _enums.experimentCategoryEnumReverse;
  }
});
Object.defineProperty(exports, "createQuantumApolloClient", {
  enumerable: true,
  get: function () {
    return _quantum.createQuantumApolloClient;
  }
});
Object.defineProperty(exports, "queryQuantumMetrics", {
  enumerable: true,
  get: function () {
    return _quantum.queryQuantumMetrics;
  }
});
Object.defineProperty(exports, "queryQuantumVariantsCounts", {
  enumerable: true,
  get: function () {
    return _quantum.queryQuantumVariantsCounts;
  }
});

var _plan = require("./setup/plan/plan");

var _roles = require("./setup/roles/roles");

var _variants = require("./setup/variants/variants");

var _metrics = require("./setup/metrics/metrics");

var _techSettings = require("./setup/techSettings/techSettings");

var _activation = require("./setup/activation/activation");

var _checkExperimentReset = _interopRequireDefault(require("./utilities/checkExperimentReset"));

var _overrides = require("./rollout/overrides/overrides");

var _sampleLaunch = require("./rollout/sampleLaunch/sampleLaunch");

var _overrideManagement = require("./overrideManagement/overrideManagement");

var _rollout = require("./rollout/rollout");

var _permissions = require("./permissions/permissions");

var _featureFlag = _interopRequireDefault(require("./featureFlag/featureFlag"));

var _sampleCalculatorEstimates = require("./featureFlag/sampleCalculatorEstimates");

var _experimentEvaluationScoreCalculation = require("./featureFlag/experimentEvaluationScoreCalculation");

var _enums = require("./enums");

var _checks = require("./checks");

var _quantum = require("./quantum/quantum");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*  Checks Experiment
* Sample Query
*
query getExperiment($id: Int!) {
  experiment(id: $id) {
    name
    summary
    hypothesis
    durationNumDays
    experimentTypeId
    experimentToProductFeatures {
      productId
      productFeatureId
    }
    experimentToUsers {
      role {
        id
      }
    }
    variants {
      name
      description
      displayOrder
    }
    activationEventUuid
  }
  metricsForExperiment(experimentId: $id) {
    id
    name
    displayName
    description
    isRequired
    isEnabled
    metricType {
      id
      name
    }
  }
   TDCSExperiment(experimentId: $id) {
        productMinVersion
        productMaxVersion
    }
}
*/
function checkExperiment({
  experiment,
  metricsForExperiment,
  TDCSExperiment
}) {
  const setUpChecks = {
    plan: (0, _plan.checkPlan)(experiment).checks,
    roles: (0, _roles.checkRoles)(experiment).checks,
    variants: (0, _variants.checkVariants)(experiment).checks,
    metrics: (0, _metrics.checkMetrics)(metricsForExperiment).checks,
    techSettings: (0, _techSettings.checkTechSettings)(TDCSExperiment).checks,
    activation: (0, _activation.checkActivation)(experiment).checks
  };
  let currentSetUpStep = Object.keys(setUpChecks).find(stepName => (0, _checks.onlyErrors)(setUpChecks[stepName]).length !== 0);
  if (!currentSetUpStep) currentSetUpStep = 'setupComplete';
  return {
    setUpChecks,
    currentSetUpStep
  };
}

function getExperimentErrors({
  experiment,
  metricsForExperiment,
  TDCSExperiment
}) {
  const setUpErrors = {
    plan: (0, _plan.checkPlan)(experiment).errors,
    roles: (0, _roles.checkRoles)(experiment).errors,
    variants: (0, _variants.checkVariants)(experiment).errors,
    metrics: (0, _metrics.checkMetrics)(metricsForExperiment).errors,
    techSettings: (0, _techSettings.checkTechSettings)(TDCSExperiment).errors,
    activation: (0, _activation.checkActivation)(experiment).errors
  };
  return {
    setUpErrors
  };
}

function nextStepForExperiment(experiment) {
  const {
    setup
  } = checkExperiment(experiment);
  Object.keys(setup).forEach();
}

function willTerminateCancelExperiment({
  durationNumDays,
  startTime
}) {
  if (startTime === null || startTime === undefined) return false;
  const diffDays = (0, _checks.dateDiffInDays)(new Date(startTime), new Date());
  return diffDays < durationNumDays;
}